import { CustomZShapedPanel2DEditorDockingPanelContent } from "./content/customZShapedPanel2DEditorDockingPanelContent";
import { DockingPanel } from "./dockingPanel";

export class CustomZShapedPanel2DEditorDockingPanel {
    private readonly panel: DockingPanel;
    private _visible: boolean;

    constructor(container: HTMLElement) {
        this._visible = false;

        const component = <CustomZShapedPanel2DEditorDockingPanelContent />;

        const containerRect = container.getBoundingClientRect();

        this.panel = new DockingPanel(container, "dextall-custom-z-panel-2d-editor", "Panel type", component, {
            style: {
                resize: "both",
            },
            dimensionsControl: {
                preventOverlapsWithViewerToolbar: true,
                widthDimensionControl: { value: 0.25 * containerRect.width, minValue: 560 },
                heightDimensionControl: { value: 0.5 * containerRect.height, minValue: 560 },
                topOffset: 2,
                rightOffset: 2,
            },
            carefullBringToFront: true,
        });

        this.panel.addToggleFullSizeButton();

        this.panel.addVisibilityListener((x: boolean) => this._visible = x);
    }

    get visible() {
        return this._visible;
    }

    setVisible(visibility: boolean) {
        if (this._visible === visibility) {
            return;
        }

        this._visible = visibility;
        this.panel.setVisible(visibility);
    }

    shutdown() {
        this.panel.shutdown();
    }
}
